var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-bar-component"},[_c('span',[_vm._v(" 【"+_vm._s(_vm.notification.title)+"】"+_vm._s(_vm.notification.content)+"（"+_vm._s(_vm.notification.created_datetime)+"） ")])])}
var staticRenderFns = []

export { render, staticRenderFns }